import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=a4ac8768&"
import script from "./preview.vue?vue&type=script&lang=ts&"
export * from "./preview.vue?vue&type=script&lang=ts&"
import style0 from "./preview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports